import InputWithActions from "./InputWithActions";

export default InputWithActions;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/InputWithActions/index.tsx